module.exports = __webpack_public_path__ + "img/IMG_2467.3ce548af.jpg";